if (typeof debounce === "undefined") {
  function debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
/**
 *  @class
 *  @function ThemeHeader
 */
if (!customElements.get("theme-header")) {
  class ThemeHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header_section = document.querySelector(".header-section");
      this.menu = this.querySelector("#mobile-menu");
      this.toggle = document.querySelector(".mobile-toggle-wrapper");

      document.addEventListener("keyup", (e) => {
        if (e.code) {
          if (e.code.toUpperCase() === "ESCAPE") {
            this.toggle.removeAttribute("open");
            this.toggle.classList.remove("active");
          }
        }
      });
      this.toggle
        .querySelector(".mobile-toggle")
        .addEventListener("click", (e) => {
          if (this.toggle.classList.contains("active")) {
            e.preventDefault();
            document.body.classList.remove("overflow-hidden");
            this.toggle.classList.remove("active");
            // Built on top of the existing toggle functionality to make the header's background white and change colors and logos
            document
              .getElementById("header")
              .classList.remove("is-mobile-menu-open");
            this.closeAnimation(this.toggle);
            if (document.getElementById("header").classList.contains("at-top")) {
            darkLogo.style.display = "none";
            darkLogo.style.opacity = "0";
            lightLogo.style.display = "block";
            lightLogo.style.opacity = "1";
            }
          } else {
            document.body.classList.add("overflow-hidden");
            setTimeout(() => {
              this.toggle.classList.add("active");
              document
                .getElementById("header")
                .classList.add("is-mobile-menu-open");
              darkLogo.style.display = "block";
              darkLogo.style.opacity = "1";
              lightLogo.style.display = "none";
              lightLogo.style.opacity = "0";
            });
          }
          window.dispatchEvent(new Event("resize.resize-select"));
        });

      // Sticky Header Class
      window.addEventListener("scroll", this.setStickyClass.bind(this), {
        passive: true,
      });
      // Mobile Menu offset
      window.addEventListener("scroll", this.setHeaderOffset.bind(this), {
        passive: true,
      });
      window.addEventListener("scroll", this.setHeaderHeight.bind(this), {
        passive: true,
      });

      window.dispatchEvent(new Event("scroll"));

      if (document.querySelector(".announcement-bar-section")) {
        window.addEventListener("scroll", this.setAnnouncementHeight(), {
          passive: true,
        });
        window.dispatchEvent(new Event("resize"));
      }

      // Buttons.
      this.menu
        .querySelectorAll("summary")
        .forEach((summary) =>
          summary.addEventListener("click", this.onSummaryClick.bind(this))
        );
      this.menu
        .querySelectorAll(".parent-link-back--button")
        .forEach((button) =>
          button.addEventListener("click", this.onCloseButtonClick.bind(this))
        );
    }

    setStickyClass() {
      if (this.classList.contains("header-sticky--active")) {
        let offset =
          parseInt(this.getBoundingClientRect().top, 10) +
          document.documentElement.scrollTop;
        this.classList.toggle(
          "is-sticky",
          window.scrollY >= offset && window.scrollY > 0
        );
      }
    }
    setAnnouncementHeight() {
      const a_bar = document.getElementById("shopify-section-announcement-bar");
      if (a_bar) {
        let h = a_bar.clientHeight;
        document.documentElement.style.setProperty(
          "--announcement-height",
          h + "px"
        );
      }
    }
    setHeaderOffset() {
      let h = this.header_section.getBoundingClientRect().top;
      document.documentElement.style.setProperty("--header-offset", h + "px");
    }
    setHeaderHeight() {
      let h = this.clientHeight;
      document.documentElement.style.setProperty("--header-height", h + "px");
    }
    onSummaryClick(event) {
      const summaryElement = event.currentTarget;
      const detailsElement = summaryElement.parentNode;
      const parentMenuElement = detailsElement.closest(".link-container");
      const isOpen = detailsElement.hasAttribute("open");

      if (this.querySelector(".parent-link-back--button")) {
        this.menu.scrollTop = 0;
      }

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
      }, 100);
    }
    onCloseButtonClick(event) {
      event.preventDefault();
      const detailsElement = event.currentTarget.closest("details");
      this.closeSubmenu(detailsElement);
    }
    closeSubmenu(detailsElement) {
      detailsElement.classList.remove("menu-opening");
      this.closeAnimation(detailsElement);
    }
    closeAnimation(detailsElement) {
      let animationStart;

      const handleAnimation = (time) => {
        if (animationStart === undefined) {
          animationStart = time;
        }

        const elapsedTime = time - animationStart;

        if (elapsedTime < 400) {
          window.requestAnimationFrame(handleAnimation);
        } else {
          detailsElement.removeAttribute("open");
        }
      };

      window.requestAnimationFrame(handleAnimation);
    }
  }
  customElements.define("theme-header", ThemeHeader);
}
/**
 *  @class
 *  @function FullMenu
 */
if (!customElements.get("full-menu")) {
  class FullMenu extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.submenus = this.querySelectorAll(
        ".thb-full-menu>.menu-item-has-children:not(.menu-item-has-megamenu)>.sub-menu"
      );

      if (!this.submenus.length) {
        return;
      }
      const _this = this;
      // resize on initial load
      window.addEventListener(
        "resize",
        debounce(function () {
          _this.resizeSubMenus();
        }, 100)
      );

      window.dispatchEvent(new Event("resize"));

      document.fonts.ready.then(function () {
        _this.resizeSubMenus();
      });
    }
    resizeSubMenus() {
      this.submenus.forEach((submenu) => {
        let sub_submenus = submenu.querySelectorAll(
          ":scope >.menu-item-has-children>.sub-menu"
        );

        sub_submenus.forEach((sub_submenu) => {
          let w = sub_submenu.offsetWidth,
            l =
              sub_submenu.parentElement.parentElement.getBoundingClientRect()
                .left +
              sub_submenu.parentElement.parentElement.clientWidth +
              10,
            total = w + l;
          if (total > document.body.clientWidth) {
            sub_submenu.parentElement.classList.add("left-submenu");
          } else if (
            sub_submenu.parentElement.classList.contains("left-submenu")
          ) {
            sub_submenu.parentElement.classList.remove("left-submenu");
          }
        });
      });
    }
  }
  customElements.define("full-menu", FullMenu);
}
document.addEventListener("DOMContentLoaded", function () {
  var header = document.getElementById("header");
  var lastScrollTop = 0;

  function updateHeaderClass() {
    var scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 200) {
      header.classList.add("scrolled");
    } else {
      header.classList.remove("scrolled");
    }

    if (scrollTop === 0) {
      header.classList.add("at-top");
      header.classList.remove("scrolled-up");
    } else if (scrollTop < lastScrollTop) {
      // Scrolling up
      header.classList.add("scrolled-up");
      header.classList.remove("scrolled");
      header.classList.remove("at-top");
    } else {
      // Scrolling down
      header.classList.remove("scrolled-up");
      header.classList.remove("at-top");
    }

    lastScrollTop = scrollTop;
  }

  // Initial check on page load
  updateHeaderClass();

  window.addEventListener("scroll", updateHeaderClass);
});
const darkLogo = document.querySelector(".logoimg--dark");
const lightLogo = document.querySelector(".logoimg--light");
/* Hover Menu Initial */
document.addEventListener("DOMContentLoaded", function () {
  const header = document.getElementById("header");
  const megaMenuItems = document.querySelectorAll(".menu-item-has-megamenu");
  const cartIcon = document.getElementById("cart--icon-custom");
  const cartIconPaths = cartIcon ? cartIcon.querySelectorAll("path") : null; 
  const topLinkHeader = document.querySelector(".top-link-header"); 
  const searchIcon = document.querySelector(".thb-quick-search svg path"); 
  const itemCount = document.querySelector(".thb-item-count"); 
  let lastScrollTop = 0;

  // Function to update the header class and logo visibility based on scroll
  function updateHeaderClass() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 200) {
      // Add scrolled class and show dark logo
      header.classList.add("scrolled");

      // Show dark logo and hide light logo
      darkLogo.style.display = "block";
      darkLogo.style.opacity = "1";
      lightLogo.style.display = "none";
      lightLogo.style.opacity = "0";
    } else {
      // Remove scrolled class and revert to light logo
      header.classList.remove("scrolled");

      darkLogo.style.display = "none";
      darkLogo.style.opacity = "0";
      lightLogo.style.display = "block";
      lightLogo.style.opacity = "1";
    }

    if (scrollTop === 0) {
      header.classList.add("at-top");
      header.classList.remove("scrolled-up");
    } else if (scrollTop < lastScrollTop) {
      // Scrolling up
      header.classList.add("scrolled-up");
      header.classList.remove("scrolled");
      header.classList.remove("at-top");

      // Show dark logo when scrolling up
      darkLogo.style.display = "block";
      darkLogo.style.opacity = "1";
      lightLogo.style.display = "none";
      lightLogo.style.opacity = "0";
    } else {
      // Scrolling down
      header.classList.remove("scrolled-up");
      header.classList.remove("at-top");

      // Show dark logo when scrolling down
      darkLogo.style.display = "block";
      darkLogo.style.opacity = "1";
      lightLogo.style.display = "none";
      lightLogo.style.opacity = "0";
    }

    lastScrollTop = scrollTop;
  }

  // Initial check on page load
  updateHeaderClass();

  // Apply scroll event listener to update the header class and logo visibility
  window.addEventListener("scroll", updateHeaderClass);

  // Hover functionality for menu items
  megaMenuItems.forEach((item) => {
    item.addEventListener("mouseenter", () => {
      if (header.classList.contains("at-top")) {
        // Change background of header to white when hovering
        header.style.backgroundColor = "white";

        // Show dark logo and hide light logo on hover
        darkLogo.style.display = "block";
        darkLogo.style.opacity = "1";
        lightLogo.style.display = "none";
        lightLogo.style.opacity = "0";

        // Change font color of the hovered menu item to black
        item.style.color = "black;";

        // Change the color of .top-link-header to black
        topLinkHeader.style.color = "black";

        // Change the fill color of all paths in the cart icon to black
        cartIconPaths.forEach(path => {
          path.style.fill = "black";
        });

        // Change the stroke color of the search icon to black
        searchIcon.style.stroke = "black";

        // Change the background color of the .thb-item-count element to black
        itemCount.style.backgroundColor = "black";
        itemCount.style.color = "white";
      }
    });

    item.addEventListener("mouseleave", () => {
      if (header.classList.contains("at-top")) {
        // Revert header background to default
        header.style.backgroundColor = "";

        // Revert logos to their default state
        darkLogo.style.display = "none";
        darkLogo.style.opacity = "0";
        lightLogo.style.display = "block";
        lightLogo.style.opacity = "1";

        // Revert font color of the menu item
        item.style.color = ""; 

        // Revert the color of .top-link-header
        topLinkHeader.style.color = ""; 

        // Revert the fill color of all paths in the cart icon
        cartIconPaths.forEach(path => {
          path.style.fill = ""; 
        });

        // Revert the stroke color of the search icon to default
        searchIcon.style.stroke = ""; 

        // Revert the background color of the .thb-item-count element
        itemCount.style.backgroundColor = ""; 
        itemCount.style.color = "";
      }
    });
  });
});